/**
 * Classification app — /apps/classification/*
 *
 * One job: an owner wants category and altitude trustworthy — clear the
 * proposal queue and confirm classification. Two screens (C Mode):
 *   /              Queue — empty + proposed items awaiting confirmation
 *   /:itemId       Review — accept / reject / set classification + authorship
 *
 * All writes go through itemClassificationStore + approve_ai_item. No new schema.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import ClassificationQueueScreen from './ClassificationQueueScreen';
import ClassificationItemScreen from './ClassificationItemScreen';

export default function ClassificationApp() {
  const app = getAppDefinition('classification')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<ClassificationQueueScreen />} />
        <Route path=":itemId" element={<ClassificationItemScreen />} />
        <Route path="*" element={<Navigate to="/apps/classification" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
